module.exports = __webpack_public_path__ + "img/product2.85ec1a93.png";